import JelWorkspace from '@/store/classes/jelWorkspace';

const jelWorkspace = new JelWorkspace({
  module: 'fournisseur',
  refreshMinProd: process.env.VUE_APP_STORE_FOURNISSEUR_REFRESH_MIN,
  refreshMinDev: process.env.VUE_APP_STORE_DEV_REFRESH_MIN,
});

const state = {
  ...jelWorkspace.state,
};
const getters = {
  ...jelWorkspace.getters,
};
const actions = {
  ...jelWorkspace.actions,
};
const mutations = {
  ...jelWorkspace.mutations,
  async INIT(state) {
    if (!state.isLoaded) {
      this.commit(`${state.module}/INTERNAL_INIT`);
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
